// These values will be populated after CDK deployment
const config = {
  // Shown as the issuer in authenticator apps and as the sign-in title.
  appName: 'drive.oller.io',
  cognito: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
    region: 'us-east-1',
  },
  api: {
    baseUrl: process.env.REACT_APP_API_URL || '',
  },
};

export default config;
